import { Component, OnInit } from '@angular/core';
import { UserService } from './_services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'vvd-front-end';

  constructor(public userService: UserService) {}

  ngOnInit(): void {
    this.userService.loadTheCurrentUser().subscribe();
  }
}
